import i18next from 'i18next';

/**
 * Column definitions for the global Users management table.
 * Plain array (no factory) — same shape as legacy
 * `_legacy/components/Users/constants.js` `USERS_MANAGING_COLUMNS`.
 */
export const USERS_MANAGING_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:firstName'),
    accessorKey: 'firstName',
    filter: {},
  },
  {
    size: 200,
    header: i18next.t('tables:lastName'),
    accessorKey: 'lastName',
    filter: {},
  },
  {
    size: 220,
    header: i18next.t('forms:email'),
    accessorKey: 'email',
    filter: {},
  },
];
